import { usePromptInputAttachments } from '@/ai-elements/prompt-input';
import { ChatInputState } from '@brandclub/bc-widgets';
import { IconImageUpload } from '../ConciergeIcons';
import React from 'react';

interface AttachmentButtonProps {
  disabled: boolean;
  styles: ChatInputState;
  resolveColor: (color: any) => string;
}

export const AttachmentButton: React.FC<AttachmentButtonProps> = ({ disabled, styles, resolveColor }) => {
  const attachments = usePromptInputAttachments();

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => attachments.openFileDialog()}
      aria-label="Attach image"
      className="tw:p-0 tw:bg-transparent tw:border-none tw:cursor-pointer disabled:tw:cursor-not-allowed tw:transition-colors"
      style={{ width: styles.iconSize, height: styles.iconSize }}
    >
      <IconImageUpload
        size={styles.iconSize}
        style={{
          color: resolveColor(styles.iconColor),
          opacity: disabled ? 0.5 : 1,
          transition: 'opacity 0.15s ease',
        }}
      />
    </button>
  );
};
